import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './KnowledgeVideoModalContent.css';

const KnowledgeVideoModalContent = ({ videoSrc, title, onClose }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const videoEl = videoRef.current;
    if (videoEl) {
      const playPromise = videoEl.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }
    return () => {
      if (videoEl) {
        videoEl.pause();
      }
    };
  }, [videoSrc]);

  return (
    <div className="video-modal">
      <button
        type="button"
        className="video-modal__close"
        onClick={onClose}
        aria-label="Cerrar video"
      >
        ×
      </button>
      {videoSrc ? (
        <video
          ref={videoRef}
          src={videoSrc}
          className="video-modal__player"
          controls
          autoPlay
          loop
          playsInline
        />
      ) : (
        <div className="video-modal__placeholder">
          <p>Video no disponible</p>
        </div>
      )}
      {title ? <p className="video-modal__caption">{title}</p> : null}
    </div>
  );
};

KnowledgeVideoModalContent.propTypes = {
  videoSrc: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func,
};

KnowledgeVideoModalContent.defaultProps = {
  videoSrc: '',
  title: '',
  onClose: undefined,
};

export default KnowledgeVideoModalContent;
